exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navContainer_50uYRMZ8 {\n    position: relative;\n    width: 1000px;\n    margin: 0 auto;\n}\n\n.nav_2ezJcnNS {\n    font-size: 18px;\n    color: #000;\n    height: 30px;\n    line-height: 30px;\n}\n\n.nav_2ezJcnNS a {\n    color: #000;\n}\n\n.nav_2ezJcnNS span {\n    padding: 0 16px;\n}\n", ""]);

// exports
exports.locals = {
	"navContainer": "navContainer_50uYRMZ8",
	"nav": "nav_2ezJcnNS"
};